<template>
  <div id="app">
    <div style="background-color:#fff;">
      <Top v-if="!$route.meta.topNoShow" />
    </div>

    <div class="box_bgColor">
      <div class="box_width">
        <keep-alive>
          <!-- 需要缓存的视图组件 -->
          <router-view v-if="$route.meta.noCache" :key="$route.fullPath" />
        </keep-alive>
        <!-- 不需要缓存的视图组件 -->
        <router-view v-if="!$route.meta.noCache" :key="$route.fullPath" />
      </div>
    </div>
    <!-- 底部导航 -->
    <Footers v-if="!$route.meta.topNoShow"></Footers>
    <!-- 底部结束 -->
  </div>
</template>

<script>
import Top from "@/components/top.vue";
import Footers from "@/components/footer.vue";
export default {
  components: {
    Top,
    Footers
  }
};
</script>

<style>
:root {
  --text-color: #1e4eff;
}
body {
  margin: 0;
  padding: 0;
  background-color: #f4f5f7;
}
img {
  object-fit: cover;
  flex-shrink: 0;
}
.box_width {
  width: 1250px;
  margin: 0 auto;
  padding: 0 15px 10px;
  box-sizing: border-box;
  /* height: calc(100vh - 40px); */
}
.box_bgColor {
  /* background: #f4f5f7; */
  padding-top: 20px;
  min-height: 100vh;
  box-sizing: border-box;
}
.outer_box_title {
  padding-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: #ff6500 2px solid;
}
.outer_box_title > div:nth-child(1) {
  border-left: #ff6500 3px solid;
  font-size: 20px;
  font-weight: bold;
  padding-left: 30px;
}
.outer_box_title > div:nth-child(2) {
  color: #ff6500;
  font-size: 12px;
  cursor: pointer;
}
.all_boxShadow_css {
  padding: 24px;
  box-sizing: border-box;
  box-shadow: 0 2px 10px 0 #e3e3e367;
  background-color: #fff;
  border-radius: 4px;
}
.collegePopularity_box {
  padding: 0 24px 24px;
  box-sizing: border-box;
  width: 100%;
  box-shadow: 0 2px 10px 0 #e3e3e367;
  background-color: #fff;
  border-radius: 4px;
}
.collegePopularity_title {
  padding: 20px 0;
  color: #000;
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
}
.collegePopularity_title::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 20px;
  background: var(--text-color);
  margin-right: 8px;
  border-radius: 0 6px 6px 0;
  position: relative;
  top: 2px;
  flex-shrink: 0;
}
.collegePopularity_subtitle {
  padding: 15px 0;
  color: #000;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
}
.collegePopularity_subtitle::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 18px;
  background: var(--text-color);
  margin-right: 8px;
  border-radius: 0 6px 6px 0;
  position: relative;
  top: 2px;
  flex-shrink: 0;
}
.flex_space_between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* 一行隐藏 */
.one_hidden {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* 两行隐藏 */
.two_hidden {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.fight_width_shrink {
  width: 340px;
  margin-left: 20px;
  flex-shrink: 0;
}
.bottom_css {
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #8d8c8b;
}
@media screen and (max-width: 450px) {
  .box_width {
    padding: 0;
    width: unset;
  }
}

/* >=450px */
@media screen and (min-width: 450px) {
}
</style>



// WEBPACK FOOTER //
// src/App.vue